import * as mutation_types from "./mutation_types";

export default {
    [mutation_types.M_SET_LOCALIZE_LIST](state, payload) {
        state.tourLocalizeList = payload
    },
    [mutation_types.M_SET_SETTINGS](state, payload) {
        state.tourSettings = payload.data;
        state.serverInit = payload.data.CacheReady;
        state.filtersAvailable = payload.data.ActualFiltersServiceAvailable;
        state.filtersInit = payload.data.ActualFiltersCacheReady
        state.quotaReady = payload.data.QuotasCacheReady;
        state.coursesReady = payload.data.CheckRealCourses;
        state.licenseStatus = payload.data.CorrectLicense;
    },
    [mutation_types.M_SET_CURRENCY](state, payload) {
        state.tourCurrency = payload.data;
        state.nationalRate = payload.data.find(x => x.IsNational);
    },
    [mutation_types.M_SET_ALL_CURRENCY](state, payload) {
        state.allCurrency = payload.data;
    },
    [mutation_types.M_LOCALIZE](state, payload) {
        state.tourLocalize = payload.data;
    },
    [mutation_types.M_SET_ALERT](state, payload) {
        clearTimeout(state.closeAlert)
        state.alertShow = true;
        state.closeAlert = setTimeout(() => {
            state.alertShow = false;
        }, payload)
    },
    [mutation_types.M_SHOW_POPOVER](state, payload) {
        state.popover.x = payload.x;
        state.popover.y = payload.y;
        state.popover.show = true;
        state.popover.text = payload.text;
        state.popover.height = payload.height;
        state.popover.nowrap = payload.nowrap;
        state.popover.preType = payload.preType;
        state.popover.down = payload.down;
    },
    [mutation_types.M_HIDE_POPOVER](state) {
        state.popover.x = -1000;
        state.popover.y = -1000;
        state.popover.show = false;
        state.popover.text = "";
    },
    [mutation_types.M_SET_SERVER_OFF](state) {
        state.serverOff = true
    },
    [mutation_types.M_SET_PATH](state, payload) {
        state.PATH =payload
    },
    [mutation_types.M_SET_API_URL](state, payload) {
        state.API_URL = payload
    },
    [mutation_types.M_SET_API_ORIGIN](state, payload) {
        state.API_ORIGIN = payload
    },
    [mutation_types.M_SET_LOCALIZE_ERROR](state) {
        state.localizeError = true
    },
    [mutation_types.M_SET_QUOTA_SERVICES](state, payload) {
        state.quotaServices = payload
    },
    [mutation_types.M_SET_CONFIG_URLS](state) {
        let passwordRecoveryUrl = document.getElementById("passwordRecoveryUrl").value;
        let registrationUrl = document.getElementById("registrationUrl").value;
        let orderListUrl = document.getElementById("orderListUrl").value;
        let mwSendReservationMails = document.getElementById("mwSendReservationMails").value;
        let orderInfo = document.getElementById("orderInfo").value;

        state.passwordRecoveryUrl = passwordRecoveryUrl.includes('http') ? passwordRecoveryUrl : state.API_ORIGIN + passwordRecoveryUrl;
        state.registrationUrl = registrationUrl.includes('http') ? registrationUrl : state.API_ORIGIN + registrationUrl;
        state.orderListUrl = orderListUrl.includes('http') ? orderListUrl : state.API_ORIGIN + orderListUrl;
        state.mwSendReservationMails = mwSendReservationMails.includes('http') ? mwSendReservationMails : state.API_ORIGIN + mwSendReservationMails;
        state.orderInfo = orderInfo;
    },
    [mutation_types.M_SET_CURRENCY_RATES](state, payload) {
        state.currencyRates = payload
    },
    [mutation_types.M_CHANGE_THEME](state, payload) {
        state.isDarkTheme = payload
    },
};
